<template>
  <div class="default-options" ref="defaultOptions">
    <span>{{$t(this.name)}}</span>

    <slot name="before"></slot>

    <img src="static/images/icons/vertical.svg"
         v-show="this.name !== 'ct-component-AccordionComponent' &&
                 this.name !== 'ct-component-PlaceMenuComponent' &&
                 this.name !== 'ct-component-VideoGalleryComponent' &&
                 this.name !== 'ct-component-SliderPageComponent'"
         v-tooltip="{content:$t('ct-option-grip-vertical'),  class: 'tooltip-custom'}"
         class="svg-icon hide-action"
         @click="alignElement('vertical')"/>

    <img src="static/images/icons/horizontal.svg"
         v-show="this.name !== 'ct-component-AccordionComponent' &&
                 this.name !== 'ct-component-PlaceMenuComponent' &&
                 this.name !== 'ct-component-VideoGalleryComponent' &&
                  this.name !== 'ct-component-SliderPageComponent'"
         v-tooltip="{content:$t('ct-option-grip-horizontal'),  class: 'tooltip-custom'}"
         class="svg-icon hide-action"
         @click="alignElement('horizontal')"/>

    <img src="static/images/icons/salvar.svg"
         v-show="this.name !== 'ct-component-AccordionComponent' &&
                 this.name !== 'ct-component-PlaceMenuComponent' &&
                 this.name !== 'ct-component-VideoGalleryComponent' &&
                 this.name !== 'ct-component-SliderPageComponent' &&
                 this.name !== 'ct-component-ContentNavUserComponent' &&
                 this.name !== 'ct-component-ButtonUserComponent'"
         v-tooltip="{content:$t('ct-option-save'),  class: 'tooltip-custom'}"
         class="svg-icon normal-action"
         @click="saveElementDefault"/>

    <img src="static/images/icons/editar.svg"
         v-tooltip="{content:$t('ct-option-edit'),  class: 'tooltip-custom'}"
         class="svg-icon normal-action"
         @click="editElement($event)"/>

    <img src="/static/images/icons/layer_down.svg"
        v-tooltip="{content:$t('ct-layer-down'),  class: 'tooltip-custom'}"
        class="svg-icon normal-action"
        @click="layer('-')"/>

    <img src="/static/images/icons/layer_up.svg"
                           v-tooltip="{content:$t('ct-layer-up'),  class: 'tooltip-custom'}"
                           class="svg-icon normal-action"
                           @click="layer('+')"/>

    <img src="static/images/icons/centralizar.svg"
         v-show="this.name !== 'ct-component-AccordionComponent' &&
                 this.name !== 'ct-component-PlaceMenuComponent' &&
                 this.name !== 'ct-component-VideoGalleryComponent' &&
                 this.name !== 'ct-component-SliderPageComponent'"
         v-tooltip="{content:$t('ct-option-center'),  class: 'tooltip-custom'}"
         class="svg-icon hide-mobile-action normal-action"
         @click="centerElement()"/>

    <slot></slot>

    <img src="static/images/icons/seta-cima.svg"
         v-show="this.name !== 'ct-component-SliderPageComponent'&&
                 this.name !== 'ct-component-VideoGalleryComponent'"
         v-tooltip="{content:$t('ct-option-arrow-up'),  class: 'tooltip-custom'}"
         class="svg-icon reorder-arrow normal-action"
         @click.stop="callReorder(-1)"/>

    <img src="static/images/icons/seta-baixo.svg"
         v-show="this.name !== 'ct-component-SliderPageComponent'&&
                 this.name !== 'ct-component-VideoGalleryComponent'"
         v-tooltip="{content:$t('ct-option-arrow-down'),  class: 'tooltip-custom'}"
         class="svg-icon reorder-arrow normal-action"
         @click.stop="callReorder(1)"/>

    <img src="static/images/icons/AI.svg"
         v-show="this.name === 'ct-component-Image3DComponent' ||
                 this.name === 'ct-component-ImageComponent'"
         v-tooltip="{ content: $t('ct-option-magic-lab'), class: 'tooltip-custom' }"
         class="svg-icon normal-action"
         @click="getImages" >

    <img src="static/images/icons/duplicar.svg"
         v-show="this.name !== 'ct-component-VideoGalleryComponent' && this.name !== 'ct-component-ContentNavUserComponent'"
         v-tooltip="{content:$t('ct-option-clone'),  class: 'tooltip-custom'}"
         class="svg-icon hide-mobile-action normal-action"
         v-on:click="duplicateElement"/>

    <img src="static/images/icons/ocultar.svg"
         v-show="this.name !== 'ct-component-VideoGalleryComponent' && this.name !== 'ct-component-ContentNavUserComponent'"
         v-tooltip="{content:$t('ct-option-hide'),  class: 'tooltip-custom'}"
         class="svg-icon normal-action"
         @click="toggle()"/>

    <div class="vr"
         v-show="this.name !== 'ct-component-VideoGalleryComponent'"></div>

    <img src="static/images/icons/deletar.svg"
         v-show="this.name !== 'ct-component-VideoGalleryComponent'"
         v-tooltip="{content:$t('ct-option-delete'),  class: 'tooltip-custom'}"
         class="svg-icon danger hide-mobile-action normal-action"
         v-on:click="deleteElement"/>
  </div>
</template>


<script>
  export default {
    name: 'OptionsElementBar',
    props: ['elem', 'name'],
    data() {
      return {}
    },
    methods: {
      centerElement: function () {
        let element = document.getElementById(this.elem.id);
        let parentNode = document.getElementById(this.elem.id).parentNode;
        let leftElement = element.offsetWidth;

        if (leftElement === 0) {
          leftElement = $('#' + this.elem.id + ' > .vdr').width();
        }

        let newLeft = (parentNode.offsetWidth / 2) - (leftElement / 2) + 'px';

        this.elem.$el.style.left = newLeft;
        this.elem.internal_config.left = newLeft;

        this.elem.$refs.resourcesData.setValuesData(this.elem);
      },
      saveElementDefault() {
        this.$root.$emit('saveElement', this.elem);
      },
      alignElement(axis) {
        this.$root.$emit('alignElement', this.elem, axis);
      },
      editElement(e) {
        this.$root.$emit('focusElement', this.elem);
        this.$root.$emit('handlerElement', this.elem, true);
        e.stopPropagation();
        e.preventDefault();
      },
      layer(direction) {
        let zIndex = this.elem.internal_config.zIndex;


        if(isNaN(zIndex)) { zIndex = 0 }

        (direction === '+') ? zIndex++  : zIndex--;

        (zIndex < 0) ? zIndex = 0 : this.elem.internal_config.zIndex = zIndex;

        this.$root.$emit('focusElement', this.elem);
        this.$root.$emit('handlerElement', this.elem, true);
      },
      toggle: function () {
        this.$root.$emit('toggleElement', this.elem);
      },
      deleteElement() {
        this.$root.$emit('deleteElement', this.elem)
      },
      duplicateElement() {
        this.$root.$emit('duplicateElement', this.elem, this.elem.internal_config);
      },
      callReorder(idx) {
        if (typeof this.elem.$parent.changeOrderPanel !== 'undefined') {
          this.elem.$parent.changeOrderPanel(this.elem, idx);
        } else {
          this.elem.$parent.$parent.changeOrderPanel(this.elem, idx);
        }

        setTimeout(() => $(`#${this.elem.id}`).trigger('click'));
      },
      getImages() {
        let values = {
          action: 'open',
          type: 'Images',
          save: this.save,
          close: this.close
        };
        this.$root.$emit('fileMananger', values);
        this.$nextTick(() => {
          document.querySelector('builderall-digital-file-repository').setAttribute('step', 'magic');
        });
      },
      close() {
        let values = {
          action: 'close',
          type: 'Images',
          save: this.save,
          close: this.close
        };
        this.$root.$emit('fileMananger', values);
      },
      save(img) {
        this.elem.$el.src = img;
        this.elem.internal_config.src = img;
        this.$root.$emit('focusElement', this.elem);
        this.$root.$emit('handlerElement', this.elem, true);

        this.close();

        // force create a new undo/redo version on change image src
        document.querySelector('.panel-components-right #settings').dispatchEvent(new MouseEvent('mousedown', {
          bubbles: true,
          cancelable: true,
        }))
      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/editor/apps/OptionsElementBar.vue